export function currencyExponent(currencyCode) {
    try {
        return (new Intl.NumberFormat('en', { style: 'currency', currency: currencyCode }).resolvedOptions()
            .maximumFractionDigits ?? 2);
    }
    catch {
        return 2;
    }
}
/** Parses a decimal string into integer minor units without floating point error (half-up rounding). */
export function toMinor(money) {
    const exponent = currencyExponent(money.currencyCode);
    const match = /^(-)?(\d*)(?:\.(\d*))?$/.exec(money.amount.trim());
    if (!match)
        return 0;
    const [, sign, whole = '', fraction = ''] = match;
    const padded = fraction.padEnd(exponent + 1, '0');
    let minor = Number(whole || '0') * 10 ** exponent + Number(padded.slice(0, exponent) || '0');
    if (Number(padded[exponent] ?? '0') >= 5)
        minor += 1;
    return sign ? -minor : minor;
}
export function fromMinor(minor, currencyCode) {
    const exponent = currencyExponent(currencyCode);
    const sign = minor < 0 ? '-' : '';
    const digits = String(Math.abs(Math.round(minor))).padStart(exponent + 1, '0');
    const amount = exponent === 0 ? digits : `${digits.slice(0, -exponent)}.${digits.slice(-exponent)}`;
    return { amount: `${sign}${amount}`, currencyCode };
}
/**
 * `narrowSymbol` keeps the currency's own symbol ("৳ 18.50") instead of falling back to the code
 * ("BDT 18.50"), which is what the default `symbol` display does whenever the viewer's locale has no
 * symbol for that currency. It is rejected by older runtimes, so plain `symbol` is the fallback.
 */
export function formatMoney(money, locale) {
    const amount = Number(money.amount);
    for (const currencyDisplay of ['narrowSymbol', 'symbol']) {
        try {
            return new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: money.currencyCode,
                currencyDisplay,
            }).format(amount);
        }
        catch {
            continue;
        }
    }
    return `${money.amount} ${money.currencyCode}`;
}
//# sourceMappingURL=money.js.map